import { IRecord } from "../types/schema"

export type IUserTeamAttribute = IRecord<"teams", "name" | "downloadPolicy">

/*
This attribute should be run on a user, to return their team.
*/
export const userTeamAttribute = {
  as: "team",
  value: {
    first: {
      attr: {
        name: "teams",
        attributes: [
          "name",
          "downloadPolicy",
          {
            name: "leaders",
            attributes: ["name"],
            filter: { matches: { isAnonymous: false, isLeaver: false } },
          },
          {
            name: "members",
            attributes: ["name"],
            filter: { matches: { isAnonymous: false, isLeaver: false } },
          },
        ],
      },
    },
  },
}
